<template lang="pug">
  .notification
    .notification__header
      .notification__title
        template(v-if="payload.daysRemain > 1")
          | Пробный период закончится через {{ payload.daysRemain }} дня
        template(v-else)
          | Пробный период закончится через {{ payload.daysRemain }} дня
      .notification__date {{ hours }}
    .notification__body
      p.notification__content
        template(v-if="payload.daysRemain > 1")
          | Самое время выбрать и оплатить один из тарифов.
        template(v-else)
          | Оплатите сейчас, чтобы гарантировать бесперебойную работу.
        router-link.notification__link(
          @click.native="emitClick"
          title="Тарифы"
          :to="{name: 'payments'}"
        ) Посмотреть тарифы
</template>

<script>
import notification from '@/mixins/notification.mixin';

export default {
  name: 'OrderReceived',
  mixins: [notification]
};
</script>
